<script>
    export let popover = null;
    export let label = null;
    export let cols = null;
    export let rows = 5;
    export let maxlength = null;
    export let disabled = false;
    export let name = null;
    export let validationName = null;
    export let placeholder = null;
    export let required = false;
    export let type = "text";
    export let value = null;
    export let inputClass = null;
    export let containerClass = null;
    export let formID = null;

    import Label from "@/components/form/Label.svelte";
    import InputError from "@/components/form/InputError.svelte";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    let hasErrors = null;

    const onKeyPress = (e) => {
        // only on enter
        if (e.charCode === 13) {
            dispatch("enter");
        }
    };
</script>

<div class="{containerClass} relative">
    {#if label}
        <Label {label} {required} {popover} />
    {/if}

    <textarea
        {cols}
        {rows}
        {maxlength}
        {disabled}
        {name}
        {placeholder}
        {required}
        {type}
        {value}
        on:input={(event) => (value = event.target.value)}
        on:keypress={onKeyPress}
        class="input w-full border {inputClass} {hasErrors
            ? '!border-red-500'
            : ''}"
    />

    {#if required}
        <span class="text-limegreen required absolute top-3 left-2.5 z-10 transition-all {value ? 'opacity-0' : 'opacity-100'}">*</span>
    {/if}

    <InputError bind:hasErrors name="{validationName ?? name}" {formID} {value}/>
</div>
